import { configureEtracker } from './etracker'
import { configureHoneybadger } from './honeybadger'

export function configure() {
  configureHoneybadger()
  configureEtracker()
}
